import { createPortal } from "react-dom";
import { ToastContainer } from "react-toastify";

/** Renders toasts on document.body so the Toastify node never adds gap inside #root. */
export default function AppToast() {
  return createPortal(
    <ToastContainer
      position="top-right"
      autoClose={3000}
      theme="colored"
      limit={4}
      newestOnTop
      pauseOnHover
      closeOnClick
      draggable
      aria-label="Notifications"
    />,
    document.body,
  );
}
